var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPinS = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18.5 10.5C18.5 6.92 15.58 4 12 4s-6.5 2.92-6.5 6.5c0 1.45.58 2.87 1.9 4.6 1.088 1.427 3.8 4.1 4.438 4.73l.122.12c.02.01.03.02.04.03.01 0 .03-.02.04-.03.25-.24 3.37-3.29 4.56-4.85 1.31-1.72 1.9-3.14 1.9-4.6m-15 0C3.5 5.81 7.31 2 12 2s8.5 3.81 8.5 8.5c0 2.26-1.04 4.16-2.31 5.82-1.278 1.672-2.775 3.13-3.947 4.272q-.432.419-.793.778c-.37.37-.88.63-1.45.63s-1.08-.26-1.45-.63q-.328-.325-.714-.699c-1.187-1.153-2.718-2.64-4.026-4.351-1.26-1.67-2.31-3.57-2.31-5.82m11.5 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
  clipRule: "evenodd"
})));
export default SvgPinS;